import * as React from "react";
import {connect} from "react-redux";
import {setAnchorPoint, SetAnchorPoint} from "../actions";
import * as selectors from "../selectors";
import LocationalState, {AnchorPoint, SelectedLocalizationType} from "../LocationalState";
import {CircleMarker, LayerGroup, Rectangle} from "react-leaflet";
import {LatLng, LatLngBounds, LeafletMouseEvent} from "leaflet";

interface TagProps {
}

interface DispatchProps {
    doSetAnchorPoint: SetAnchorPoint,
}

interface StateProps {
    listenForAnchorPoint: AnchorPoint,
    startAnchor: LatLng,
    endAnchor: LatLng,
    selectedLocalizationType: SelectedLocalizationType
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        listenForAnchorPoint: selectors.listenForAnchorPoint(state),
        startAnchor: selectors.startAnchor(state),
        endAnchor: selectors.endAnchor(state),
        selectedLocalizationType: selectors.selectedLocalizationType(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetAnchorPoint: setAnchorPoint,
});

class Component extends React.Component<Props, {}> {

    render() {
        const {listenForAnchorPoint, startAnchor, endAnchor, selectedLocalizationType} = this.props;
        const clickBounds = new LatLngBounds([[73.67820340963792, 53.28154850296755], [47.83441819636963, -6.393906597034536]]);

        return (
            <LayerGroup>
                {listenForAnchorPoint !== null && (
                    <Rectangle bounds={clickBounds} opacity={0} fillOpacity={0} className="anchor-layer" onClick={(e: LeafletMouseEvent) => this.handleSetAnchorPoint(e)}/>
                )}
                {startAnchor && (
                    <CircleMarker center={startAnchor} radius={10} />
                )}
                {(endAnchor && selectedLocalizationType === SelectedLocalizationType.LINE) && (
                    <CircleMarker center={endAnchor} radius={10} />
                )}
            </LayerGroup>
        );
    }

    handleSetAnchorPoint(e: LeafletMouseEvent) {
        this.props.doSetAnchorPoint(this.props.listenForAnchorPoint, e.latlng)
    };

}

export const LocationalAnchorLayer = connect(mapStateToProps, mapDispatchToProps)(Component);